"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Courses = void 0;
const sdk_1 = require("../sdk");
var Courses;
(function (Courses) {
    Courses.getAllCourses = (options) => {
        const url = '/courses';
        return sdk_1.SDK.axios.get((0, sdk_1.appendSearchParams)(url, options));
    };
    Courses.getCourse = (options) => {
        const url = `/courses/${options.courseId}`;
        return sdk_1.SDK.axios.get((0, sdk_1.appendSearchParams)(url, options));
    };
    Courses.getSections = (courseId, options) => {
        const url = `/courses/${courseId}/sections`;
        return sdk_1.SDK.axios.get((0, sdk_1.appendSearchParams)(url, options));
    };
    Courses.createSection = (data, options) => {
        const url = `/courses/${options.courseId}/sections`;
        return sdk_1.SDK.axios.post(url, data);
    };
})(Courses = exports.Courses || (exports.Courses = {}));
//# sourceMappingURL=courses.js.map